import { IThemeComponentVariation } from '@belong/types';
import { getButtonVariants } from './button';

export const componentVariations = (): IThemeComponentVariation => ({
  accordion: {
    iconButtonColor: 'BELONG_BLUE_ALT'
  },
  button: getButtonVariants(),
  card: {
    backgroundColor: 'WHITE',
    borderColor: 'GREY_200'
  },
  icon: {
    spotBackgroundColor: 'GREY_200'
  },
  inclusion: { iconColor: 'BLACK' }
});
